<div class="small-layout">
  <input
    type="text"
    class="form-control mb-2 keypad-input"
    [value]="lastKeys"
    readonly
    style="text-align: center; font-size: 1.2em; background: #f5f5f5"
  />
  <div class="keypad-container mb-1">
    <button
      class="key"
      *ngFor="let num of [1, 2, 3, 4, 5, 6, 7, 8, 9]"
      (click)="onDigitClick(num)"
      [disabled]="disabled || !deviceRegistered"
    >
      {{ num }}
    </button>
    <button
      class="key"
      (click)="onDigitClick('*')"
      [disabled]="disabled || !deviceRegistered"
    >
      +<sup style="color: #9e9e9e; vertical-align: middle">*</sup>
    </button>
    <button
      class="key"
      (click)="onDigitClick(0)"
      [disabled]="disabled || !deviceRegistered"
    >
      0
    </button>
    <button
      class="key"
      (click)="onDigitClick('#')"
      [disabled]="disabled || !deviceRegistered"
    >
      #
    </button>
    <button
      class="key call-btn"
      (click)="openModal($event)"
      [disabled]="disabled || !deviceRegistered"
      *ngIf="showCallBtn"
    >
      + Call
    </button>
    <button
      class="key back-btn"
      [disabled]="disabled || !deviceRegistered"
      (click)="onBackspaceClick()"
      *ngIf="showCallBtn"
    >
      <span class="back-icon"><i class="ti ti-backspace"></i></span>
    </button>
  </div>
</div>
